import $ from 'jquery'
import '@lib/responsive_image_maps'

$(() => {
  $('img[usemap]').rwdImageMaps()
})
